export default {};



// WEBPACK FOOTER //
// ./src/store/modules/courseMap/state.js